import { render, staticRenderFns } from "./ExpressionAnswerDisplay.vue?vue&type=template&id=01ec8f72&scoped=true&"
import script from "./ExpressionAnswerDisplay.vue?vue&type=script&lang=js&"
export * from "./ExpressionAnswerDisplay.vue?vue&type=script&lang=js&"
import style0 from "./ExpressionAnswerDisplay.vue?vue&type=style&index=0&id=01ec8f72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ec8f72",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
